import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t} from "@lingui/macro";
import BukkuTooltip from "../../Tooltip";
import {EyeInvisibleOutlined} from "@ant-design/icons";
import ContactTypes from "../../ContactTypes";
import {EmailTd, EmailTdWidth} from "../../Table/Common/EmailTd";
import AmountTd from "../../Table/Common/AmountTd";
import {CreatedAtColumn} from "../../Table/Common/CreatedAtTd";
import TransactionEmailStatus from "../../TransactionEmailStatus";
import ContactListMenu from "../../ListMenu/Contact";
import {CustomFieldHelper} from "../../../shared/CustomFieldHelper";
import Tags from "../../Table/Cell/Tags";
// import ContactMandatePopoverTag from '../../../containers/AppPage/Contacts/Mandate/components/MandatePopoverTag';
import { FilesPreview } from '../../FilesPreview';
import { FileListModule } from '../../FileUploaderListManager/enum/FileListModule';
import MyInvoisReady from '../MyInvoisReady';

function getColumns(props, fields) {
    const { companyCurrencyCode, companyCountryCode, openDrawer } = props;

    const renderDivWithTooltip = (text, isDefaultAddressCell, tooltipPlacement) => (
        <div className="ellipsis-div" style={{ lineHeight: '16px' }}>
            {
                text ? (
                    <BukkuTooltip
                        placement={tooltipPlacement || undefined}
                        overlayInnerStyle={{whiteSpace: isDefaultAddressCell ? 'pre-line' : ''}}
                    >
                        {text}
                    </BukkuTooltip>
                ) : '-'
            }
        </div>
    );

    const renderAmountCell = (text, companyCurrencyCode) => (
        <AmountTd currency_code={companyCurrencyCode} amount={text} />
    );

    const columns = [
        {
            title: t`Legal Name`,
            key: 'legal_name',
            dataIndex: 'legal_name',
            fixed: 'left',
            width: 155,
            ellipsis: true,
            render: (text, record) => (
                <div className="center-vertically">
                    <span className="ellipsis-div" style={{lineHeight: '16px'}}>
                        <BukkuTooltip placement="topLeft">{record.legal_name}</BukkuTooltip>
                    </span>
                    <span>
                        {
                            record.is_archived ? (
                                <>
                                    &nbsp;
                                    <EyeInvisibleOutlined />
                                </>
                            ) : null
                        }
                        {
                            companyCountryCode === 'MY' ? (
                                <>
                                &nbsp;
                                    <MyInvoisReady record={record} />
                                </>
                            ) : null
                        }

                    </span>
                </div>
            ),
        },
        {
            title: t`Contact Code`,
            key: 'contact_code',
            dataIndex: 'contact_code',
            width: 120,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Type`,
            dataIndex: 'type',
            key: 'type',
            width: 130,
            render: (text, record) => (
                <div className="ellipsis-div">
                    <ContactTypes record={record} />
                </div>
            ),
        },
        {
            title: t`Reg / ID No`,
            dataIndex: "reg_no",
            key: "reg_no",
            width: 140,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Other Name`,
            dataIndex: "other_name",
            key: "other_name",
            width: 150,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Billing First Name`,
            dataIndex: "billing_first_name",
            key: "billing_first_name",
            width: 120,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Billing Last Name`,
            dataIndex: "billing_last_name",
            key: "billing_last_name",
            width: 120,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Shipping First Name`,
            dataIndex: "shipping_first_name",
            key: "shipping_first_name",
            width: 120,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Shipping Last Name`,
            dataIndex: "shipping_last_name",
            key: "shipping_last_name",
            width: 120,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        {
            title: t`Billing Party`,
            dataIndex: "billing_party",
            key: "billing_party",
            width: 150,
            ellipsis: true,
            render: text => renderDivWithTooltip(text, true, "topLeft"),
        },
        {
            title: t`Shipping Party`,
            dataIndex: "shipping_party",
            key: "shipping_party",
            width: 150,
            ellipsis: true,
            render: text => renderDivWithTooltip(text, true, "topLeft"),
        },
        {
            title: t`Email`,
            dataIndex: 'email',
            key: 'email',
            width: EmailTdWidth,
            align: 'left',
            ellipsis: true,
            render: text => (
                <div>
                    <BukkuTooltip title={text}>
                        &nbsp;
                        <EmailTd email={text} />
                        &nbsp;
                    </BukkuTooltip>
                </div>
            ),
        },
        {
            title: t`Telephone`,
            dataIndex: 'phone_no',
            key: 'phone_no',
            width: 140,
            ellipsis: true,
            render: text => renderDivWithTooltip(text),
        },
        // {
        //     title: t`Mandate`,
        //     dataIndex: 'mandate',
        //     key: 'mandate',
        //     width: 140,
        //     render: (text, record) => <ContactMandatePopoverTag
        //         contact={record}
        //     />,
        // },
        {
            title: t`Groups`,
            dataIndex: 'group_names',
            key: 'group_names',
            width: 140,
            ellipsis: true,
            render: (text, record) => <Tags list={record.group_names} />,
        },
        ...CustomFieldHelper.getColumns(fields.contact, true),
        {
            title: t`Receivable`,
            dataIndex: 'receivable_amount',
            key: 'receivable_amount',
            width: 150,
            align: 'right',
            ellipsis: true,
            render: text => renderAmountCell(text, companyCurrencyCode),
        },
        {
            title: t`Payable`,
            dataIndex: 'payable_amount',
            key: 'payable_amount',
            align: 'right',
            width: 150,
            render: text => renderAmountCell(text, companyCurrencyCode),
        },
        {
            key: 'net_receivable_amount',
            dataIndex: 'net_receivable_amount',
            title: t`Net Receivable`,
            width: 150,
            align: 'right',
            render: text => renderAmountCell(text, companyCurrencyCode),
        },
        CreatedAtColumn,
        {
            key: 'email_status',
            dataIndex: "email_status",
            title: t`Email Tracker`,
            width: 35,
            render: (text, record) => <TransactionEmailStatus record={record} isContact />,
        },
        {
            key: 'files',
            dataIndex: "files",
            title: t`Files`,
            width: 35,
            render: (text, record) => <FilesPreview type={FileListModule.CONTACT} record={record} />,
        },
        {
            key: 'action',
            title: t`Action`,
            width: 150,
            render: (text, record) => <ContactListMenu record={record} openDrawer={openDrawer} />,
        },
    ];

    return columns;
}

export default {
    storageKey: StorageKey.contacts,
    sortable: [
        'legal_name',
        'receivable_amount',
        'payable_amount',
        'created_at',
        'contact_code',
    ],
    required: [
        'legal_name',
        'action',
    ],
    defaulto: [
        'type',
        'reg_no',
        'receivable_amount',
        'payable_amount',
        'email_status',
        'files',
        'contact_code',
    ],
    hideTitle: [
        'email_status',
        'files',
    ],
    getColumns,
};
